import { render, staticRenderFns } from "./DataReportDetail.vue?vue&type=template&id=94bc5514&scoped=true&"
import script from "./DataReportDetail.vue?vue&type=script&lang=js&"
export * from "./DataReportDetail.vue?vue&type=script&lang=js&"
import style0 from "./DataReportDetail.vue?vue&type=style&index=0&id=94bc5514&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94bc5514",
  null
  
)

export default component.exports